<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                     <v-card-text>
                         <v-container fluid>
                              <v-layout row wrap>
                                    <v-col cols="12">
                                        <h2 class="mb-3">Quote Declined</h2>
                                        <p>The client has declined your quote. Please acknowledge the enquiry is now cancelled below.</p>
                                        <p>All prices are in {{ reservation.hotel.hotel_name }}'s local currency {{ reservation.hotel.currency.currency_name }}</p>
                                        <p v-if="reservation.hotel.currency.currency_code != 'GBP'">Exchange rate for this record: {{ reservation.quote_exchange_rate }}{{ reservation.hotel.currency.currency_code }} to 1GBP</p>
                                    </v-col>

                                    <v-col cols="12" md="3">
                                        <strong>Total Rate:</strong>
                                    </v-col>
                                    <v-col cols="12" md="9">
                                        {{ reservation.quote_amount_local.toFixed(2) }} {{ reservation.hotel.currency.currency_code }}
                                    </v-col>
                        

                                    <v-col cols="12" md="3">
                                        <strong>Quote:</strong>
                                    </v-col>
                                    <v-col cols="12" md="9" v-if="units.length">
                                       <div v-for="(unit, index) in units">
                                       <fieldset>
                                           <legend>Unit {{ (index + 1)}}: {{ unit.roomTypeName }}{{ unit.is_alternative ? " - alternative" : "" }}</legend>

                                            <v-layout row>
                                                <v-col cols="12">
                                                       {{ unit.guests.adults ? unit.guests.adults + " adults" : "" }}
                                                       {{ unit.guests.olderChildren ? unit.guests.olderChildren + " older children" : "" }}
                                                       {{ unit.guests.youngChildren ? unit.guests.youngChildren + " children" : "" }}
                                                       {{ unit.guests.babies ? unit.guests.babies + " babies" : "" }},
                                                       {{ unit.rateTypeName }}
                                                </v-col>

                                                <v-col cols="6" md="3" class="pa-1"><strong>Date</strong></v-col>
                                                <v-col cols="6" md="3" class="pa-1"><strong>Rate Amount ({{ reservation.hotel.currency.currency_code }})</strong></v-col>
                                                <v-col cols="6" md="3" class="pa-1"><strong>Commission %</strong></v-col>
                                                <v-col cols="6" md="3" class="pa-1"><strong>Commission Amount ({{ reservation.hotel.currency.currency_code }})</strong></v-col>

                                                <v-col cols="12" v-for="datePrice in unit.pricesPerDate">
                                                    <v-layout row>
                                                        <v-col cols="6" md="3" class="pa-1">{{ dateFormatDDMYYYYDay(datePrice.date) }}</v-col>

                                                        <v-col cols="6" md="3" class="pa-1">
                                                            {{ datePrice.rateAmount.toFixed(2) }}
                                                        </v-col>
                                                        
                                                        <v-col cols="6" md="3" class="pa-1">
                                                            {{ datePrice.commissionPercentage }}
                                                        </v-col>

                                                        <v-col cols="6" md="3" class="pa-1">
                                                            {{ datePrice.commissionAmount.toFixed(2) }}
                                                        </v-col>
                                                    </v-layout>
                                                </v-col>
                                            </v-layout>
                                       </fieldset>
                                       </div>
                                   </v-col>


                                    <v-col cols="12" md="3">
                                        <strong>Taxes and Fees:</strong>
                                    </v-col>
                                    <v-col cols="12" md="9">
                                       <fieldset v-for="fee,index in reservation.additional_fees">
                                           <legend>Fee {{ (index + 1) }}: {{ fee.name }}</legend>
                                           <v-layout row>

                                           <v-col cols="12" v-if="fee.description">{{ fee.description }}</v-col>
                                           <v-col cols="12">
                                               {{ fee.fee_value.toFixed(2) }} {{ fee.fee_application_type == 2 ? "%" : reservation.hotel.currency.currency_code }}
                                               {{ feeCategoryAsString(fee.hotel_additional_fee_type_key) }}, 
                                               billed {{ feeTypeAsString(fee.fee_application_type) }},
                                               payable to {{ feePayableAsString(fee.is_payable_to) }}
                                           </v-col>

                                       </v-layout>
                                       </fieldset>
                                   </v-col>


                                  <v-col cols="3">
                                      <strong>Deposit:</strong>
                                  </v-col>

                                  <v-col cols="9">
                                      <div v-if="reservation.depositRequired"><strong>Deposit required at time of booking {{ reservation.deposit_amount_local }} {{ reservation.hotel.currency.currency_code }}</strong></div>
                                      <div v-if="reservation.is_advance_payment">Full pre-payment charged to the client by i-escape to secure the booking</div>
                                      <div v-if="!reservation.is_advance_payment && reservation.type_of_hotel == 'UPF' && reservation.hotel.collect_deposit == 1">Amount charged to the client by i-escape to secure the booking</div>
                                      <div v-if="!reservation.is_advance_payment && reservation.type_of_hotel == 'ARR' && (!reservation.voucher_key)">i-escape has not charged the clients card</div>
                                  </v-col>


                                  <v-col cols="3">
                                      <strong>Payment Policy:</strong>
                                  </v-col>

                                  <v-col cols="9">
                                      <v-layout row wrap>
                                          <v-col cols="12" v-for="unit in reservation.units">
                                              <strong>{{ unit.rate_type.name }}</strong>
                                              <div>{{ unit.policy_payment_text }}</div>
                                          </v-col>
                                      </v-layout>
                                  </v-col>


                                  <v-col cols="3">
                                      <strong>Cancellation Policy:</strong>
                                  </v-col>

                                  <v-col cols="9">
                                      <v-layout row wrap>
                                          <v-col cols="12"  v-for="policy in getCancellationPolicies(reservation)">
                                              <div><strong>{{ policy.name }}</strong></div>
                                              <div>{{ policy.text }}</div>
                                          </v-col>
                                      </v-layout>
                                  </v-col>


                              </v-layout>
                          </v-container>
                      </v-card-text>

                      <v-card-actions>
                          <v-btn class="ies-green" 
                              title="Acknowledge the client declined the reservation"
                              v-on:click="confirmDeclined">Confirm Declined</v-btn>
                      </v-card-actions>
                 </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    /**
     * A Vue component dedicated to letting the user update the quote for a reservation
     *
     * Props:
     *     int 'reservationkey' - The ID of the reservation to display
     */
    import axios from 'axios';
    // Import the application event bus so we can listen for data changes and react accordingly
    import EventBus from '@/eventBus';
    export default {

        name: 'hotel-reservation-change-rooms-rates',
        props: ['reservationkey'],
        data () {
            return {
                reservation: {},
                units: [],
            }
        },
        methods: {

            /**
             * Register event listener that will be listening for clearSelector event to clear it's selected state
             */
            setUpEventListeners() {
                EventBus.$on('Reservation Administration: Reservation changed', this.onReservationChanged);
            },

            /**
             * @method onReservationChanged
             * 
             * Respond to the reservation having been edited
             * by checking if the event is talking about this reservation,
             * and if so then reload it afresh so we are displaying all of
             * the correct data across the board
             * 
             * @param payload 
             */
            onReservationChanged(payload){
                if (payload.reservationKey == this.reservationkey){
                   this.loadReservation();
                }
            },

            loadReservation(){
                axios.get('/api/reservations/id/' + this.reservationkey)
                .then(function(response){
                    this.reservation = response.data.reservation;
                    this.reservation.depositRequired = this.reservation.hotel.collect_deposit || this.reservation.is_advance_payment || ((this.reservation.hotel.hotel_payment_policy.deposit_required == 1) || (this.reservation.hotel.hotel_payment_policy.deposit_required == 2));


                    this.units = [];
                    this.reservation.units.forEach(function(unit){
                        var thisUnit = {"ID":null, "reservationKey":this.reservation.reservation_key, "roomTypeKey":null, "roomTypeName":"", "rateTypeKey":null, "rateTypeName":"", "guests": {"babies":0, "youngChildren": 0, "olderChildren":0, "adults": 0}, "quoteTotal": 0.0, "commission": 0.0, "isIndicative":false, "isAlternative": false, "shouldDelete":false, "paymentPolicyText":"", "pricesPerDate":[]};

                        // The basics
                        thisUnit.ID = unit.reservation_unit_key;
                        thisUnit.reservationKey = unit.reservation_key;
                        thisUnit.roomTypeKey = unit.hotel_room_key;
                        thisUnit.roomTypeName = unit.room ? unit.room.name : "";
                        thisUnit.rateTypeKey = unit.rate_type_key;
                        thisUnit.rateTypeName = unit.rate_type ? unit.rate_type.name : "";
                        thisUnit.isAlternative = unit.is_alternative;
                        thisUnit.isIndicative = unit.is_indicative;

                        // Guests
                        thisUnit.guests.adults = unit.occ_adults;
                        thisUnit.guests.olderChildren = unit.occ_oldchildren;
                        thisUnit.guests.youngChildren = unit.occ_children;
                        thisUnit.guests.babies = unit.occ_babies;

                        // Money
                        thisUnit.commission = unit.commission;
                        thisUnit.commissionOverallPercentage = 0;// @todo this is actually an overall value from its individual unit dates
                        thisUnit.quoteTotal = unit.total;

                        // Policies
                        thisUnit.paymentPolicyText = unit.policy_payment_text;

                        // Prices per date
                        unit.std_rates.forEach(function(stdRate){ 
                            thisUnit.pricesPerDate.push({"date": stdRate.date, "rateAmount": stdRate.rate, "commissionPercentage": stdRate.commission, "commissionAmount": ((stdRate.rate / 100.0) * stdRate.commission)})
                        }.bind(this));

                        console.log("thisunit", thisUnit);

                        this.units.push(thisUnit);
                    }
                    .bind(this));

                }.bind(this));
            },

            addUnit:function(){
                var thisUnit = {"ID":null, "reservationKey":this.reservation.reservation_key, "roomTypeKey":null, "rateTypeKey":null, "guests": {"babies":0, "youngChildren": 0, "olderChildren":0, "adults": 0}, "pricesPerDate":[]};
                this.units.push(thisUnit);
            },

            getRoomTypes:function(){
                var self = this;
                axios.get('/api/hotel/' + this.reservation.hotel_key + '/room-types')
                .then(function(response){
                    this.roomTypes = response.data;
                    this.roomTypes.forEach(function(roomType){
                        this.roomTypeOptions.push({ text: roomType.name, value: roomType.hotel_room_key });
                    }.bind(this));
                }.bind(this));
            },

            getRateTypes: function(){
                var self = this;
                axios.get('/api/hotel/' + this.reservation.hotel_key + '/rate-types')
                .then(function(response){
                    this.rateTypes = response.data;
                    this.rateTypes.forEach(function(rateType){
                        this.rateTypeOptions.push({ text: rateType.name, value: rateType.rate_type_key });
                    }.bind(this));
                }.bind(this));
            },

            /**
             * Push the changes up to the server
             */
            saveChanges(){
                var params = {
                    units: this.units
                };
                axios.post('/api/reservation/' + this.reservationkey + '/set-prices', params)
                .then(function(response){
                    alert("Prices updated");
                    EventBus.$emit('Reservation Administration: Reservation changed', {'reservationKey': this.reservationkey});
                    EventBus.$emit('Reservation Administration: Task change', {'reservationKey': this.reservationkey, 'taskName': 'manage reservation'});
                }.bind(this));
            },
            cancel(){
                EventBus.$emit('Reservation Administration: Task change', {'reservationKey': this.reservationkey, 'taskName': 'manage reservation'});
            },

            switchToEditRooms(){
                EventBus.$emit('Reservation Administration: Task change', {'reservationKey': this.reservationkey, 'taskName': 'changeRoomsAndRates'});
            },


            /**
             * @method dateFormatDDMYYYYDay
             *
             * Takes a date string in the format YYYY-MM-DD and returns it in the designed format
             * e.g. '17 September 2025, Wednesday'
             *
             * @param String dateString
             * @return String
             */
            dateFormatDDMYYYYDay(dateString){
               var parts = dateString.replace('T', '-').split('-');
               var myDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]), 0, 0, 0);
               return myDate.getDate() + " " + this.getMonthName(myDate.getMonth()) + " " + myDate.getFullYear() + ", " + this.getDayName(myDate.getDay());
            },

            getMonthName(monthIndex){
                switch(monthIndex){
                    case 0: return "January";
                    case 1: return "February";
                    case 2: return "March";
                    case 3: return "April";
                    case 4: return "May";
                    case 5: return "June";
                    case 6: return "July";
                    case 7: return "August";
                    case 8: return "September";
                    case 9: return "October";
                    case 10: return "November";
                    case 11: return "December";
                }
                return "Unknown";
            },


            getDayName(dayIndex){
                switch(dayIndex){
                    case 0: return "Sunday";
                    case 1: return "Monday";
                    case 2: return "Tuesday";
                    case 3: return "Wednesday";
                    case 4: return "Thursday";
                    case 5: return "Friday";
                    case 6: return "Saturday";
                }
                return "Unknown";
            },

            recalcCommAmount(datePrice){
                datePrice.commissionAmount = (datePrice.rateAmount / 100) * datePrice.commissionPercentage;
                console.log(datePrice);
            },

            recalcCommPercentage(datePrice){
                datePrice.commissionPercentage = (datePrice.commissionAmount / datePrice.rateAmount) * 100;
                console.log(datePrice);
            },




            feeCategoryAsString(feeCategory){
                switch(feeCategory){
                    case 1: return "government tax";
                    case 2: return "service charge";
                    case 3: return "city/tourist tax";
                    case 4: return "cleaning fee";
                    case 5: return "miscellaneous fee";
                }
                return "(category not set)";
            },
            feeTypeAsString(applicationType){
                switch(applicationType){
                    case 1: return "none";
                    case 2: return "percentage of quote";
                    case 3: return "extra";
                    case 4: return "per room";
                    case 5: return "per unit";
                    case 6: return "per person per night";
                    case 7: return "per person per stay";
                    case 8: return "per stay";
                }
                return "application type not set";
            },
            feePayableAsString(isPayableTo){
                switch(isPayableTo){
                    case 1: return "included in quote";
                    case 2: return "added to quote";
                    case 3: return "the property";
                    case 4: return "unknown (property to confirm)";
                }
                return "recipient not set";
            },

            getCancellationPolicies(reservation){
                var policies = [];
                reservation.units.forEach(function(unit){
                    policies.push({'name': unit.rate_type.name, 'text': unit.cancellation_policy.policy_cancel_text});
                });
                return policies;
            },
        },
        
        /**
         * Once mounted this component needs to load the reservation specified
         */
        mounted() {
            this.loadReservation();
            this.setUpEventListeners();
        },

        computed: {}
    }
</script>
